<template>
    <div class="pb-2 space-y-8">
        <!-- Actions -->
        <div>
            <MeetingDetailsSectionTitle iconName="bolt">
                Actions
            </MeetingDetailsSectionTitle>
            <div class="flex flex-col lg:flex-row items-center gap-1 mt-2">
                <RecurringMeetingRefundButtonModal
                    :bookingData="bookingData"
                    @onSuccess="
                        emits('onBookingRefunded', {
                            bookingData: $event.bookingData,
                        })
                    "
                />
                <RecurringMeetingCancelAllMeetingButton
                    :bookingData="bookingData"
                />
            </div>
        </div>

        <div class="space-y-8">
            <RecurringMeetingDatesSection
                :meetingRecurringDatesInAvailabilityTimezone="
                    bookingData.meetingRecurringDatesInAvailabilityTimezone
                "
            />
            <BookingPaymentSection
                v-if="bookingPayment"
                :bookingPayment="bookingPayment"
            />
            <MeetingCustomFieldsSection
                v-if="bookingData.customFieldResponsesData.length > 0"
                :customFieldResponsesData="bookingData.customFieldResponsesData"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import BookingData from '@/App/Booking/Booking/Entity/BookingData'
    import MeetingDetailsSectionTitle from '@/App/Booking/Meeting/Component/MeetingDetailsSectionTitle.vue'
    import BookingPaymentSection from '@/App/Booking/Meeting/Component/BookingPaymentSection.vue'
    import MeetingCustomFieldsSection from '@/App/Booking/Meeting/Component/MeetingCustomFieldsSection.vue'
    import RecurringMeetingDatesSection from '@/App/Booking/Recurring/Component/RecurringMeetingDatesSection.vue'
    import RecurringMeetingRefundButtonModal from '@/App/Booking/Recurring/Component/RecurringMeetingRefundButtonModal.vue'
    import RecurringMeetingCancelAllMeetingButton from '@/App/Booking/Recurring/Component/RecurringMeetingCancelAllMeetingButton.vue'

    const emits = defineEmits<{
        onBookingRefunded: [{ bookingData: BookingData }]
        onBookingCanceled: [{ bookingData: BookingData }]
    }>()

    const props = defineProps({
        bookingData: {
            type: Object as PropType<BookingData>,
            required: true,
        },
    })

    const bookingPayment =
        props.bookingData.getSingleExistingReservationData().bookingPayment
</script>
